<svelte:options accessors/>
<script>
    import NauiFilters from "../../naui/components/NauiFilters.svelte";
    import Chart from 'chart.js/auto';
    import {onMount} from 'svelte';

    export let filters;
    export let title;

    let filtersCmpt;
    let canvas;
    let chartRef;

    export let costs;
    export let values;

    let data = {
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'Costo Servicio',
                data: costs,
                backgroundColor: 'rgb(73, 88, 103)',
                borderColor: 'rgb(73, 88, 103)',
                borderWidth: 1
            },
            {
                label: 'Facturado',
                data: values,
                backgroundColor: 'rgb(201, 217, 207)',
                borderColor: 'rgb(201, 217, 207)',
                borderWidth: 1
            }
        ]
    };

    onMount(() => {
        const config = {
            type: 'bar',
            data: data,
            options: {
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            },
        };

        chartRef = new Chart(canvas, config);
    });

    export function refreshChart() {
        data.datasets[0].data = costs;
        data.datasets[1].data = values;

        console.log(chartRef);
        chartRef.update();
    }

</script>

<div class="py-15">
    <NauiFilters bind:this={filtersCmpt} {filters} on:filtered/>
</div>

<div class="p-15 shadow radius 2">
    <h2 class="text-l mb-1">{title}</h2>
    <!--    <img src="https://via.placeholder.com/1200x300">-->
    <canvas bind:this={canvas} width="1200" height="300"></canvas>
</div>